import React from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectPassengerBreakdownAssistanceTotals } from 'redux/slices/timeline-reports/timeline-reports';

// display order for assistance codes
import { TARGET_CODES } from '_utils/constants';

const AssistanceBreakdownCard = () => {
  const assistanceTotals = useSelector(selectPassengerBreakdownAssistanceTotals);

  // only show when assistance is toggled on and the range spans more than one day
  if (!assistanceTotals || assistanceTotals.days <= 1) return null;

  const { totals, grandTotal } = assistanceTotals;

  const codes = [...TARGET_CODES, 'OTHER'];

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    marginBottom: '24px',
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '8px',
  };

  const titleStyle = {
    fontSize: '14px',
    fontWeight: '500',
    color: '#6b7280',
    margin: 0,
  };

  const grandTotalStyle = {
    fontSize: '32px',
    fontWeight: '700',
    color: '#111827',
    lineHeight: '1',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
    gap: '16px',
  };

  const codeTitleStyle = {
    fontSize: '12px',
    fontWeight: '600',
    color: '#6b7280',
    margin: '0 0 4px 0',
    textTransform: 'uppercase',
  };

  const codeValueStyle = {
    fontSize: '22px',
    fontWeight: '700',
    color: '#111827',
    margin: 0,
    lineHeight: '1',
  };

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <p style={titleStyle}>Total Assistance Breakdown ({assistanceTotals.days} days)</p>
        <div>
          <span style={grandTotalStyle}>{grandTotal}</span>
          <span style={{ ...titleStyle, marginLeft: '8px' }}>total assistances</span>
        </div>
      </div>

      <div style={gridStyle}>
        {codes.map((code) => (
          <div key={code}>
            <p style={codeTitleStyle}>{code}</p>
            <p style={codeValueStyle}>{totals[code] || 0}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssistanceBreakdownCard;
